import { TransactionInformation } from 'src/types/redux/transaction.redux.type';
import { EventType, StateType } from 'src/types/redux/user.redux.types';
import { StateResultType } from 'src/types/services/state-service.type';
import { getTransactionListForStatus } from './getTransactionListForStatus.helper';

let allToStateNames: { id: string | undefined; stateName: string | undefined }[] = [];

export const transactionForSelectList = ({
  enumType,
  statusId,
  isEditMode,
  userState,
  transactionList,
  stateNodeList,
}: {
  enumType: number;
  statusId?: string;
  isEditMode: boolean;
  userState: StateType;
  transactionList: TransactionInformation[];
  stateNodeList: StateResultType[];
}) => {
  if (!(userState.userRoles.length > 0)) return allToStateNames;

  if (isEditMode) {
    return getTransactionListForStatus(transactionList, enumType, userState, stateNodeList, statusId);
  } else {
    allToStateNames = [];

    stateNodeList
      .filter((option) => option.flowChartType === enumType && option.isDefault === true)
      .map((obj) => allToStateNames.push({ id: obj.id, stateName: obj.stateName }));

    return allToStateNames;
  }
};
